type Callback = (...args: unknown[]) => void

/**
 * Tiny, dependency-free typed event emitter used by `Sizes`, `Time` and
 * `Resources` to broadcast `resize` / `tick` / `ready` events.
 */
export default class EventEmitter {
  private callbacks = new Map<string, Callback[]>()

  public on(name: string, callback: Callback): this {
    const list = this.callbacks.get(name) ?? []
    list.push(callback)
    this.callbacks.set(name, list)
    return this
  }

  public off(name: string, callback?: Callback): this {
    if (!callback) {
      this.callbacks.delete(name)
      return this
    }

    const list = this.callbacks.get(name)
    if (list) {
      this.callbacks.set(
        name,
        list.filter((registered) => registered !== callback),
      )
    }
    return this
  }

  public trigger(name: string, ...args: unknown[]): void {
    this.callbacks.get(name)?.forEach((callback) => callback(...args))
  }
}
